import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ZetrixService } from '../../services/ZetrixService/zetrix';
import { ZetrixStatusResponse } from '../../models/zetrix.dto';
import { extractErrorMessage } from '../../shared/error-utils';
import { ErrorBanner } from '../../shared/components/error-banner/error-banner';

type HealthAccent = 'green' | 'amber' | 'red' | 'muted';

@Component({
  selector: 'app-zetrix-status',
  imports: [CommonModule, ErrorBanner],
  templateUrl: './zetrix-status.html',
  styleUrl: './zetrix-status.scss',
})
export class ZetrixStatus implements OnInit {
  status = signal<ZetrixStatusResponse | null>(null);
  isLoading = signal(false);
  errorMessage = signal('');

  constructor(private zetrix: ZetrixService) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.isLoading.set(true);
    this.errorMessage.set('');

    this.zetrix.status().subscribe({
      next: (res) => {
        this.isLoading.set(false);
        this.status.set(res.data);
      },
      error: (err: HttpErrorResponse) => {
        this.isLoading.set(false);
        this.errorMessage.set(extractErrorMessage(err, 'Failed to load Zetrix status.'));
      },
    });
  }

  get healthLabel(): string {
    const s = this.status();
    if (!s) return '';
    if (!s.enabled) return 'Disabled';
    if (!s.canWrite) return 'Not configured';
    return s.detail === 'reachable' ? 'Healthy' : 'Unreachable';
  }

  get healthAccent(): HealthAccent {
    const s = this.status();
    if (!s) return 'muted';
    if (!s.enabled) return 'muted';
    if (!s.canWrite) return 'amber';
    return s.detail === 'reachable' ? 'green' : 'red';
  }
}
